import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const fetchTransferEmployeeData = async (data: any) => {
	try {
		const URL = `${API_URL}TransferEmployeeDetails`;
		if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
		if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
		const requestData = {
			fetchTransferEmployeeToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchTransferEmployeeData:', error);
		throw error;
	}
};

export const fetchAllTransfersData = async (data: any) => {
	try {
		const URL = `${API_URL}GetAllEmployeeTransfers`;
		if (process.env.NODE_ENV === 'development') console.log('Get All Transfers API URL:', URL);
		if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
		const requestData = {
			fetchAllTransfersToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchAllTransfersData:', error);
		throw error;
	}
};

export const deleteTransferData = async (data: any) => {
	try {
		const URL = `${API_URL}DeleteTransferEmployee`;
		if (process.env.NODE_ENV === 'development') console.log('Delete Transfer API URL:', URL);
		if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
		const requestData = {
			deleteTransferToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		if (process.env.NODE_ENV === 'development') console.error('Error in deleteTransferData:', error);
		throw error;
	}
};
